import React from 'react';
import './HeroSection.css';
import platformPreview from '../../assets/wisby-platform-hero.png';

// Componente `ArrowIcon` que renderiza esta parte de la interfaz.
const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

// Componente `HeroSection` que renderiza esta parte de la interfaz.
export default function HeroSection({ onNavigate }) {
  // Función `scrollToSolutions` que encapsula una operación reutilizable de este módulo.
  const scrollToSolutions = () => {
    document.getElementById('about-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero-section-wisby" aria-labelledby="wisby-hero-title">
      <div className="hero-background-glow" aria-hidden="true" />

      <div className="hero-content-wisby">
        <div className="hero-copy-wisby">
          <h1 id="wisby-hero-title">
            Tu abogado<br />
            corporativo<br />
            <span>siempre</span><br />
            a la mano
          </h1>

          <p className="hero-description">
            Tu seguridad legal está más cerca. Gestiona tus títulos accionarios,
            poderes y necesidades corporativas, todo desde un solo lugar.
          </p>

          <div className="hero-buttons-group">
            <button type="button" onClick={scrollToSolutions} className="hero-action-button">
              Explorar soluciones
              <ArrowIcon />
            </button>
            <button
              type="button"
              onClick={() => onNavigate('nosotros')}
              className="hero-secondary-button"
            >
              Cómo funciona
            </button>
          </div>
        </div>

        <div className="hero-visual-wisby">
          <div className="hero-preview-glow" aria-hidden="true" />
          <figure className="hero-preview-frame">
            <img
              src={platformPreview}
              alt="Vista de la plataforma Wisby para generar y revisar documentos legales"
              fetchPriority="high"
              decoding="async"
            />
          </figure>
          <p className="hero-preview-caption">Gestiona tus procesos legales desde un solo lugar.</p>
        </div>
      </div>
    </section>
  );
}
